import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import Cookies from 'universal-cookie';
import axios from 'axios';
import moment from 'moment';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { inject, observer } from 'mobx-react';
import PolicyPanel from '../../components/policy/PolicyPanel';
import SignatureModal from '../../components/signature/SignatureModal';
import ForecastPane from '../../components/forecast/ForecastPane';
import CountdownTimer from '../../components/countdown-timer/CountdownTimer';
import AtgChat from '../../components/atg-chat/AtgChat';
//import ChangesButton from "../../components/changes-button/ChangesButton";
import TransitionDialog from '../../components/transition-dialog/TransitionDialog';
import { FETCH_URL } from '../../constants/ServerLinks';
import MoneyTransfer from '../../components/money-transfer/MoneyTransfer';

export const GD_OFF = 0;
export const GD_START = 1;
export const GD_PHASE = 2;
export const GD_END = 3;
export const GD_RESTART = 4;

@observer
class PolicyDashboard extends Component {
  constructor(props) {
    super(props);

    this.fetchURL = FETCH_URL;
    this.cookies = new Cookies();
    this.countryName = this.cookies.get('country_name');
    this.sName = this.cookies.get('s_name');
    this.worldId = this.cookies.get('world_id');
    this.skey = this.cookies.get('world_skey');
    this.countryId = this.cookies.get('country_id');
    this.roleId = this.cookies.get('role_id');
    this.pid = this.cookies.get('p_id');
    this.roleName = this.cookies.get('role_name');
    this.roleAlias = this.cookies.get('role_alias');
    this.currentYear = this.cookies.get('current_year');
    this.configNumber = this.cookies.get('config_number');
    this.countryEventSource = null;
    this.worldEventSource = null;
    this.messagesEventSource = null;
    this.ws_scheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
    this.worldSocket = null;
    this.countrySocket = null;

    this.state = {
      signatureModal: false,
      hasSubmitted: false,
      participantInfo: {},
      polInPlay: [],
      forecastRequestSent: false,
      resetRequestSent: false,
      hasGameStarted: false,
      gameHasAdvanced: true,
      polTime: parseInt(props.polTime),
      snackMsg: 'Welcome!',
      snackOpen: false,
      snackType: 'snack-success',
      gameDialog: {
        gdState: GD_OFF,
        gdDescription:
          'This is a notification. Please click on Okay to continue.',
        newsArticles: [],
      },
      // policyReasoning: '',
      hasChanged: false,
      transferRequestSent: false,
      moneyTransactions: {},
      atgTransactions: {},
      atgFund: 0, // Push as prop to MoneyTransfer
      currentPresident: '',
      buttonAlert: false,
      atgButtonAlert: false,
      cancelTo: '',
      atgCancelTo: '',
      forecastData: {
        cost: 0.0,
        discord: 0.0,
        employ: 0.0,
        favorability: 0.0,
        gdp: 0.0,
        hrt: 0.0,
        eqt: 0.0,
        a0: 0,
        b0: 0,
        c0: 0,
        d0: 0,
        totPop: 0,
      },
      messages: [],
      messageCount: 0,
      clicked: false,
    };
    this.fetchCurrentData();
    this.pollingFunctions();
    this.fetchTransactions();
    this.fetchATGTransactions();
    this.fetchATGFund();
  }
  // randomPresident = () => {
  //     //if not equal to this.state.currentPresident then set it equal, else do it again; loop conditional
  //     // let countriesList = ["Ottania", "Capalla", "Durrit"];
  //     // //remove this.state.currentPresident from the array and then pickNew
  //     // let filtered = countriesList.filter(x => x != this.state.currentPresident);
  //     // let pickNew = filtered[Math.floor(Math.random() * filtered.length)];

  //     this.setState(() => {
  //         return {
  //             currentPresident: pickNew,
  //         };
  //     });
  // };

  showSignatureModal = (e) => {
    e.preventDefault();

    this.setState(() => {
      return {
        signatureModal: true,
      };
    });
  };

  hideSignatureModal = () => {
    this.setState(() => {
      return {
        signatureModal: false,
      };
    });
  };

  hasSubmitted = (val) => {
    this.setState(() => {
      return {
        hasSubmitted: val,
      };
    });
  };

  policyValueChanged = (value, polId, values = null) => {
    if (this.state.polInPlay.length > 0) {
      if (value) {
        this.setState((prevState) => {
          return {
            polInPlay: prevState.polInPlay.map((p) => {
              if (p[0] === polId) {
                return [p[0], parseInt(value)];
              } else {
                return p;
              }
            }),
            hasChanged: true,
          };
        });
      } else {
        this.setState((prevState) => {
          return {
            polInPlay: prevState.polInPlay.map((p) => {
              if (p[0] === polId) {
                return [p[0], 0, values];
              } else {
                return p;
              }
            }),
            hasChanged: true,
          };
        });
      }

      return true;
    } else {
      this.setState({
        snackOpen: true,
        snackMsg: 'Game not started yet.',
        snackType: 'snack-error',
      });

      return false;
    }
  };

  submitPolicies = () => {
    console.group('PolicyDashboard:submitPolicies');
    // console.log("Submit Policies");

    const policyList = this.state.polInPlay;
    // const policy_reasoning = this.state.policyReasoning;

    axios
      .post(this.fetchURL + '/api/v1/policies/submissions/', {
        country_id: this.countryId,
        role_id: this.roleId,
        policy_list: policyList,
        role_name: decodeURI(this.roleName),
        s_name: decodeURI(this.sName),
        // policy_reasoning: policy_reasoning,
      })
      .then((response) => {
        // console.log(response.data);
        if (response.data.success) {
          // console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-success',
          });
        } else {
          // console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
      });
    console.groupEnd();
  };

  addToQueue = () => {
    console.group('PolicyDashboard:addToQueue');
    // console.log("Add Policies to Queue");

    const policyList = this.state.polInPlay;

    axios
      .post(this.fetchURL + '/api/v1/policies/queue/', {
        country_id: this.countryId,
        role_id: this.roleId,
        policy_list: policyList,
      })
      .then((response) => {
        // console.log(response.data);
        if (response.data.success) {
          // console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-success',
          });
        } else {
          // console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
      });
    console.groupEnd();
  };

  // ----  NEED THIS FOR PM TO GET UPDATED POLICIES FROM OTHER PLAYERS ---- //

  updateWithCurrentData = () => {
    this.props.world
      .fetchWorld()
      .then(() => {})
      .catch((error) => {
        console.log(error.response);
      });

    axios
      .all([
        axios.get(this.fetchURL + '/api/v1/policies/submissions/', {
          params: {
            world_id: this.worldId,
            country_id: this.countryId,
            last_year: true,
          },
        }),
      ])

      .then(
        axios.spread((polSubResponse) => {
          // console.group("PolicyDashboard:updateWithCurrentData");
          // console.log("polSubResponse: ", polSubResponse.data.data);
          // console.groupEnd();
          let polInPlay = polSubResponse.data.data[0];
          this.setState({ polInPlay: polInPlay });
        })
      );
  };

  fetchCurrentData = (e = null, showStart = true) => {
    if (e !== null) {
      e.preventDefault();
      this.setState(() => ({ resetRequestSent: true }));
    }

    this.props.world
      .fetchWorld()
      .then(() => {})
      .catch((error) => {
        console.log(error.response);
      });

    axios
      .all([
        axios.get(this.fetchURL + '/api/v1/policies/submissions/', {
          params: {
            world_id: this.worldId,
            country_id: this.countryId,
            last_year: true,
          },
        }),
        // axios.get(this.fetchURL + '/api/v1/policies/reasoning/', {
        //     params: {
        //         country_id: this.countryId,
        //     }
        // }),
        axios.get(this.fetchURL + '/api/v1/worlds/status/', {
          params: { world_id: this.worldId },
        }),
      ])
      // .then(axios.spread((polSubResponse, resoningResponse, worldResponse) => {
      .then(
        axios.spread((polSubResponse, worldResponse) => {
          // console.group("PolicyDashboard:fetchCurrentData");
          // console.log("polSubResponse: ", polSubResponse.data.data);
          // console.log(resoningResponse.data.data);
          // console.log(worldResponse.data.data);
          // console.groupEnd();
          this.setState(() => ({ resetRequestSent: false }));
          let polInPlay = polSubResponse.data.data[0];
          // let reasoning = Object.values(resoningResponse.data.data)[0];
          let worldInfo = worldResponse.data.data;

          if (showStart) {
            if (worldInfo.has_started) {
              this.setState({ hasGameStarted: worldInfo.has_started });
              // Show game started modal!
              this.setState({ currentPresident: worldInfo.atg_pres });
              this.changeTransitionDialogState(GD_START);
            }
          }

          if (e !== null) {
            this.setState({
              polInPlay: polInPlay,
              // policyReasoning: reasoning,
              hasGameStarted: worldInfo.has_started,
              hasChanged: false,
            });
          } else {
            this.setState({
              polInPlay: polInPlay,
              hasGameStarted: worldInfo.has_started,
              hasChanged: false,
            });
          }
        })
      )
      .catch((error) => {
        console.log(error.response);
        this.setState(() => ({ resetRequestSent: false }));
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
      });
  };

  fetchWorldInfo = () => {
    axios
      .get(this.fetchURL + '/api/v1/worlds/status/', {
        params: { world_id: this.worldId },
      })
      .then((response) => {
        // console.group("PolicyDashboard:fetchWorldInfo");
        // console.log(response.data.data);
        // console.groupEnd();
        let worldInfo = response.data.data;

        if (
          worldInfo.is_complete === true &&
          parseInt(this.currentYear) !== parseInt(worldInfo.current_year)
        ) {
          this.cookies.set('current_year', worldInfo.current_year);
          this.currentYear = worldInfo.current_year.toString();
          // console.log("Game has ended");
          this.setState({ hasGameStarted: worldInfo.has_started });
          this.changeTransitionDialogState(GD_END);
          this.fetchCurrentData(null, false);
          this.props.onGameComplete(true);
        } else if (
          parseInt(this.currentYear) < parseInt(worldInfo.current_year)
        ) {
          this.cookies.set('current_year', worldInfo.current_year);
          this.currentYear = worldInfo.current_year.toString();
          // console.log("Game advanced");
          this.setState({ currentPresident: worldInfo.atg_pres });
          this.changeTransitionDialogState(GD_PHASE);
          this.fetchCurrentData(null, false);
        } else if (
          parseInt(this.currentYear) > parseInt(worldInfo.current_year)
        ) {
          this.cookies.set('current_year', worldInfo.current_year);
          this.currentYear = worldInfo.current_year.toString();
          // console.log("Game restarted");
          this.setState({ hasGameStarted: worldInfo.has_started });
          this.changeTransitionDialogState(GD_RESTART);
          this.fetchCurrentData(null, false);
        } else if (worldInfo.has_started !== this.state.hasGameStarted) {
          // console.log("Game has started");
          this.setState({ hasGameStarted: worldInfo.has_started });
          this.setState({ currentPresident: worldInfo.atg_pres });
          this.fetchCurrentData(null, true);
          this.changeTransitionDialogState(
            worldInfo.has_started
              ? GD_START
              : this.state.gameDialog === GD_OFF
                ? GD_OFF
                : GD_RESTART
          );
        }
        // console.log("THE CURRENT PRESIDENT", this.state.currentPresident);
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
      });
  };

  forecast = (migrantInflux) => {
    this.setState({ forecastRequestSent: true });

    // console.group("PolicyDashboard:forecast");
    // console.log("Forecast Policies");

    const policyList = this.state.polInPlay;

    axios
      .post(this.fetchURL + '/api/v1/policies/forecast/country/', {
        country_id: this.countryId,
        policy_list: policyList,
        migrant_influx: parseInt(migrantInflux),
      })
      .then((response) => {
        // console.group("PolicyDashboard:forecast:reply");
        // console.log(response.data.data);
        this.setState({ forecastRequestSent: false });
        if (response.data.success) {
          // console.log(response.data.message);

          const f_data = response.data.data;
          const forecastData = {
            cost: f_data.cost[f_data.cost.length - 1],
            discord: f_data.discord[f_data.discord.length - 1],
            employ: f_data.employ,
            favorability: f_data.favorability,
            gdp: f_data.gdp[f_data.gdp.length - 1],
            hrt: f_data.hrt,
            eqt: f_data.eqt,
            a0: f_data.refugees.a0AllInCountry,
            b0: f_data.refugees.b0AllInCountry,
            c0: f_data.refugees.c0AllInCountry,
            d0: f_data.refugees.d0AllInCountry,
            totPop:
              f_data.refugees.a0AllInCountry +
              f_data.refugees.b0AllInCountry +
              f_data.refugees.c0AllInCountry +
              f_data.refugees.d0AllInCountry,
          };

          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-success',
            attemptsLeft: response.data.data.forecast_attempts,
            forecastData: forecastData,
          });
          this.pollingFunctions();
        } else {
          // console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
          });
        }
        // console.groupEnd();
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ forecastRequestSent: false });
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
      });
    // console.groupEnd();
  };

  getMessages = () => {
    // console.log("Inside get messages, world Id: ", this.worldId);
    axios
      .get(this.fetchURL + '/api/v1/atgchat/', {
        params: { world_id: this.worldId },
      })
      .then((res) => {
        // console.log(res.data.data);
        if (res.data.success) {
          const messages = res.data.data;
          // console.log(messages);
          this.setState({ messages });
        } else {
          // console.log("No ATG messages yet!")
          // this.setState({
          //   snackOpen: true,
          //   snackMsg: "No messages yet",
          //   snackType: "snack-error",
          // });
        }
      })
      .catch((err) => {
        console.log(err.message);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
      });
  };

  sendMessage = (e) => {
    e.preventDefault();
    // console.log("sending a message...");
    axios
      .post(this.fetchURL + '/api/v1/atgchat/', {
        world_id: this.worldId,
        skey: this.skey,
        sender_id: this.pid,
        sender_country: this.countryName,
        message: this.state.senderMessage,
        created: moment(Date.now()).format(),
      })
      .then((res) =>
        this.setState({
          senderMessage: '',
        })
      )
      .catch((err) => console.log(err.message));
  };

  showBox = () => {
    if (!this.state.clicked) {
      this.setState({
        clicked: true,
        messageCount: 0,
      });
    } else {
      this.setState({
        clicked: false,
      });
    }
  };

  /*
      International Financial Commitments (used by PM)
    */
  sendMoney = (sendTo, amount) => {
    // console.group("PolicyDashboard:sendMoney");

    if (sendTo === 'null') {
      this.setState({
        snackOpen: true,
        snackMsg: 'Select a country',
        snackType: 'snack-error',
      });
      // console.groupEnd();
      return new Promise(() => {
        throw new Error('Country not selected');
      });
    } else if (amount === 0) {
      this.setState({
        snackOpen: true,
        snackMsg: 'Enter amount to be sent',
        snackType: 'snack-error',
      });
      // console.groupEnd();
      return new Promise(() => {
        throw new Error('Amount is 0');
      });
    } else {
      return axios
        .post(this.fetchURL + '/api/v1/money_transactions/', {
          from_country_id: this.countryId,
          to_country_id: sendTo,
          amount: parseInt(amount),
          world_skey: this.skey,
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.success) {
            // console.log(response.data.message);
            this.setState((prevState) => ({
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: 'snack-success',
              // moneyTransactions: prevState.moneyTransactions.concat(response.data.data)
            }));
            this.props.cb();
            // console.groupEnd();
            this.fetchTransactions();
            // window.location.reload();
          } else {
            // console.log(response.data.message);
            this.setState({
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: 'snack-error',
            });
            // console.groupEnd();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.setState({
            snackOpen: true,
            snackMsg: 'Something went wrong. Please try again later.',
            snackType: 'snack-error',
          });
          // console.groupEnd();
        });
    }
  };

  /*
      Called when Send Money in "ATG Financial Commitments" Panel,
      which is MoneyTransfer.js
    */
  sendMoneyATG = (sendTo, amount) => {
    // console.group("PolicyDashboard:sendMoneyATG");
    // console.log("country", sendTo);
    // console.log("amount", amount);

    if (sendTo === 'null') {
      this.setState({
        snackOpen: true,
        snackMsg: 'Select a country',
        snackType: 'snack-error',
      });
      // console.groupEnd();
      return new Promise(() => {
        throw new Error('Country not selected');
      });
    } else if (amount === 0) {
      this.setState({
        snackOpen: true,
        snackMsg: 'Enter amount to be sent',
        snackType: 'snack-error',
      });
      // console.groupEnd();
      return new Promise(() => {
        throw new Error('Amount is 0');
      });
    } else {
      return axios
        .post(this.fetchURL + '/api/v1/atg_transactions/', {
          from_country_id: this.countryId,
          to_country_id: sendTo,
          amount: parseInt(amount),
          world_skey: this.skey,
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.success) {
            // console.log(response.data.message);
            this.setState((prevState) => ({
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: 'snack-success',

              // atgTransactions: prevState.atgTransactions.concat(response.data.data)
            }));
            this.props.cb();
            // console.groupEnd();
            this.fetchATGTransactions();
            this.fetchTransactions();
            this.fetchATGFund();
            // window.location.reload();
          } else {
            // console.log(response.data.message);
            this.setState({
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: 'snack-error',
            });
            // console.groupEnd();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.setState({
            snackOpen: true,
            snackMsg: 'Something went wrong. Please try again later.',
            snackType: 'snack-error',
          });
          // console.groupEnd();
        });
    }
  };

  onCancelMoney = (fromCountry, toCountry) => {
    axios
      .post(this.fetchURL + '/api/v1/cancel_money/', {
        from_country_name: fromCountry,
        to_country_name: toCountry,
        world_id: this.worldId,
        world_skey: this.skey,
      })
      .then((response) => {
        // console.log(response)
        if (response.data.success) {
          // console.log("success")
          this.setState({ cancelTo: '' });
          // this.fetchTransactions()
          // this.fetchATGTransactions()
        } else {
          console.log(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  onCancelATGMoney = (fromCountry, toCountry) => {
    axios
      .post(this.fetchURL + '/api/v1/cancel_atg_money/', {
        from_country_name: fromCountry,
        to_country_name: toCountry,
        world_id: this.worldId,
        world_skey: this.skey,
      })
      .then((response) => {
        // console.log(response)
        if (response.data.success) {
          this.setState({ atgCancelTo: '' });
          // console.log("success")
          // this.fetchTransactions()
          // this.fetchATGTransactions()
        } else {
          // console.log(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  fetchTransactions = () => {
    const params =
      this.roleName !== 'ATG Delegate'
        ? {
            country_id: this.countryId,
          }
        : {
            world_id: this.worldId,
          };

    axios
      .get(this.fetchURL + '/api/v1/money_transactions/', {
        params: params,
      })
      .then((response) => {
        // console.group("PolicyDashboard:fetchTransactions");
        // console.log(response.data.data);
        // console.log(this.countryId);
        // console.log(this.worldId);
        // console.groupEnd();
        let moneyTransactions = response.data.data;

        this.setState({
          moneyTransactions: moneyTransactions,
        });
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  fetchATGTransactions = () => {
    axios
      .get(this.fetchURL + '/api/v1/atg_transactions/', {
        params: {
          country_id: this.countryId,
          world_id: this.worldId,
        },
      })
      .then((response) => {
        // console.group("PolicyDashboard:fetchATGTransactions");
        // console.log(response.data.data);
        // console.groupEnd();
        let atgTransactions = response.data.data;

        this.setState({
          atgTransactions: atgTransactions,
        });
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  fetchATGFund = () => {
    axios
      .get(this.fetchURL + '/api/v1/metrics/', {
        params: {
          country_id: this.countryId,
        },
      })
      .then((response) => {
        let metrics = response.data.data;

        // console.group("PolicyDashboard:fetchATGFund");
        // console.log(metrics);
        // console.log(metrics.atgfund[0]);
        // console.groupEnd();

        this.setState({
          // atgFund: metrics.atgfund[0],
          atgFund: metrics.atgfund.slice(-1)[0],
        });
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  fetchQueue = () => {
    axios
      .get(this.fetchURL + '/api/v1/policies/queue/', {
        params: {
          country_id: this.countryId,
        },
      })
      .then((response) => {
        // console.group("PolicyDashboard:fetchQueue");
        // console.log(response.data.data);
        // console.groupEnd();

        if (response.data.success) {
          let queueData = response.data.data.queue;
          let years = queueData ? Object.keys(queueData).sort() : [];
          let lastYear = years.length > 0 ? years[years.length - 1] : undefined;

          let updatedPolicies = [];
          this.state.polInPlay.forEach((pol) => {
            const tempPol = queueData[lastYear][pol[0]];
            if (tempPol) {
              if (parseInt(tempPol[0]) === 0) {
                updatedPolicies.push([pol[0], tempPol[0], tempPol[1]]);
              } else {
                updatedPolicies.push([pol[0], tempPol[0]]);
              }
            } else {
              updatedPolicies.push(pol);
            }
          });

          lastYear &&
            this.setState({
              polInPlay: updatedPolicies,
              snackOpen: true,
              snackMsg: 'Policy Decisions Synced to Policy Screen as per Queue',
              snackType: 'snack-success',
            });
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: 'snack-error',
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          snackOpen: true,
          snackMsg: 'Something went wrong. Please try again later.',
          snackType: 'snack-error',
        });
      });
  };

  openPane = (e) => {
    e.preventDefault();

    const dashWrap = document.querySelector('.policy__dash__wrap');
    const canvas = document.querySelector('.policy__dash__offCanvas');
    //push canvas left
    canvas.classList.add('canvas-is-open');
    //push main container left
    dashWrap.classList.add('push-left');
    dashWrap.classList.add('overlay-visible');
  };

  closePane = () => {
    const dashWrap = document.querySelector('.policy__dash__wrap');
    const canvas = document.querySelector('.policy__dash__offCanvas');
    //push canvas left
    canvas.classList.remove('canvas-is-open');
    //push main container left
    dashWrap.classList.remove('push-left');
    dashWrap.classList.remove('overlay-visible');
  };

  pollingFunctions = () => {
    this.fetchWorldInfo();
    this.updateWithCurrentData();
    this.getMessages();
    this.props.cb();
  };

  transactionFunctions = () => {
    this.fetchTransactions();
    this.fetchATGTransactions();
    this.fetchATGFund();
    this.props.cb();
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(() => ({
      [name]: value,
    }));
  };

  handleClose = () => {
    this.changeTransitionDialogState();
    this.setState({ snackOpen: false });
  };

  changeTransitionDialogState = (gdState) => {
    const myIdentifier =
      'CONFIG_' + this.configNumber + '_' + this.currentYear.toString();
    const myArticles = this.props.articles.articles.filter(
      (article) => article.conditional_identifier === myIdentifier
    );

    switch (gdState) {
      case GD_START:
        this.setState(() => ({
          gameDialog: {
            gdState: GD_START,
            gdDescription: 'The game has started.',
            newsArticles: myArticles,
          },
        }));
        return true;
      case GD_PHASE:
        this.setState(() => ({
          gameDialog: {
            gdState: GD_PHASE,
            gdDescription: `The instructor has advanced the game to year ${
              this.currentYear
            }.`,
            newsArticles: myArticles,
          },
        }));
        return true;
      case GD_END:
        this.setState(() => ({
          gameDialog: {
            gdState: GD_END,
            gdDescription: 'The game has ended 🎉.',
            newsArticles: myArticles,
          },
        }));
        return true;
      case GD_RESTART:
        this.setState(() => ({
          gameDialog: {
            gdState: GD_RESTART,
            gdDescription: 'The game is restarting.',
            newsArticles: myArticles,
          },
        }));
        return true;
      default:
        this.setState(() => ({
          gameDialog: {
            gdState: GD_OFF,
            newsArticles: [],
          },
        }));
        return true;
    }
  };

  shouldComponentUpdate = (nextProps) => {
    if (nextProps.std !== this.props.std) {
      this.fetchQueue();
    }
    return true;
  };

  eventListeners = () => {
    let world_path = '';
    let country_path = '';
    if (window.location.hostname === 'localhost') {
      world_path =
        this.ws_scheme + '://localhost:7000/worldsocket/' + this.skey;
      country_path =
        this.ws_scheme + '://localhost:7000/countrysocket/' + this.countryId;
    } else {
      world_path =
        this.ws_scheme + '://refugee.dmsi-sims.com/worldsocket/' + this.skey;
      country_path =
        this.ws_scheme +
        '://refugee.dmsi-sims.com/countrysocket/' +
        this.countryId;
    }
    this.worldSocket = new ReconnectingWebSocket(world_path);
    this.countrySocket = new ReconnectingWebSocket(country_path);

    this.worldSocket.addEventListener('open', (e) => {
      // console.log("ws opened", e)
    });
    this.worldSocket.addEventListener('close', (e) => {
      // console.log("ws closed", e)
    });
    this.worldSocket.addEventListener('message', (e) => {
      // console.log("ws message received", JSON.parse(e.data))
      const data = JSON.parse(e.data);
      const message = JSON.parse(e.data).message;
      if (message === 'received message') {
        const messages = JSON.parse(e.data).data;
        let messageCount = 0;
        let newMessageCount = 0;
        if (parseInt(messages.length) && parseInt(this.state.messages.length)) {
          messageCount =
            parseInt(messages.length) - parseInt(this.state.messages.length);
          newMessageCount = this.state.messageCount + messageCount;
        } else {
          newMessageCount = parseInt(messages.length);
        }
        if (!this.state.clicked) {
          this.setState({
            messageCount: newMessageCount,
          });
        }
        this.setState({
          messages,
        });
      }

      if (data.message.message === 'world advanced started') {
        this.setState({
          snackOpen: true,
          snackMsg: `The instructor has initiated world advance, please wait...`,
          snackType: 'snack-success',
          gameHasAdvanced: false,
        });
      }
      if (data.message.message === 'world advanced') {
        this.pollingFunctions();
        this.setState({
          snackOpen: true,
          snackMsg: `The world has been advanced by the Instructor`,
          snackType: 'snack-success',
          gameHasAdvanced: true,
        });
      }
      if (data.message.message === 'world started') {
        this.pollingFunctions();
        this.setState({
          snackOpen: true,
          snackMsg: `The world has been started.`,
          snackType: 'snack-success',
        });
      }
      if (data.message.message === 'money sent') {
        this.transactionFunctions();
        this.setState({
          snackOpen: true,
          snackMsg: `Monetary commitments have been updated.`,
          snackType: 'snack-success',
        });
      }
      if (data.message.message === 'ATG money sent') {
        this.transactionFunctions();
        this.setState({
          snackOpen: true,
          snackMsg: `ATG commitments have been updated.`,
          snackType: 'snack-success',
        });
      }
      if (data.message.message === 'commitment cancelled') {
        this.transactionFunctions();
        this.setState({
          snackOpen: true,
          snackMsg: `${
            data.message.from_country_name
          } has cancelled its commitments for ${
            data.message.to_country_name
          }. `,
          snackType: 'snack-success',
        });
      }
      if (data.message.message === 'ATG commitment cancelled') {
        this.transactionFunctions();
        this.setState({
          snackOpen: true,
          snackMsg: `${
            data.message.from_country_name
          } has cancelled ATG commitments for ${
            data.message.to_country_name
          }. `,
          snackType: 'snack-success',
        });
      }
      if (data.message.message === 'world reset') {
        this.pollingFunctions();
        this.setState({
          snackOpen: true,
          snackMsg: `The world has been reset, you will now be redirected to choose a role and country again.`,
          snackType: 'snack-success',
        });
        // console.log("skey: ", this.skey, "player id: ", this.pid, "student name: ", this.sName)
        setInterval(() => {
          this.cookies.remove('role_id');
          this.cookies.remove('config_number');
          this.cookies.remove('country_id');
          this.cookies.remove('country_name');
          this.cookies.remove('current_year');
          this.cookies.remove('origin');
          this.cookies.remove('p_id');
          this.cookies.remove('role_alias');
          this.cookies.remove('role_name');
          this.cookies.remove('s_name');
          this.cookies.remove('uid');
          this.cookies.remove('world_id');
          this.cookies.remove('world_name');
          this.cookies.remove('world_skey');
          window.location.replace(
            `/student/${this.skey}/${this.pid}/${this.sName}/NOT_CLSG/`
          );
        }, 2000);
      }
    });
    this.worldSocket.addEventListener('error', (e) => {
      // console.log("ws error", e);
    });

    this.countrySocket.addEventListener('open', (e) => {
      // console.log("ws opened", e);
    });
    this.countrySocket.addEventListener('close', (e) => {
      // console.log("ws closed", e);
    });
    this.countrySocket.addEventListener('message', (e) => {
      console.log('ws message received', e);
      const data = JSON.parse(e.data).message;
      console.log(data);
      if (data.message === 'policy submitted') {
        this.pollingFunctions();
        this.setState({
          snackOpen: true,
          snackMsg: `Policy was changed by ${data.role} -- ${data.player_name}`,
          snackType: 'snack-success',
        });
      }
    });
    this.countrySocket.addEventListener('error', (e) => {
      console.log('ws error', e);
    });
  };

  moneyAlert = (e) => {
    const toCountry = e.target.getAttribute('tocountry');
    this.setState({ cancelTo: toCountry });
  };
  cancelMoneyAlert = (e) => {
    e.preventDefault();
    const toCountry = e.target.getAttribute('tocountry');
    this.setState({ cancelTo: '' });
  };

  atgMoneyAlert = (e) => {
    e.preventDefault();
    const toCountry = e.target.getAttribute('tocountry');
    this.setState({ atgCancelTo: toCountry });
  };
  cancelAtgMoneyAlert = (e) => {
    const toCountry = e.target.getAttribute('tocountry');
    this.setState({ atgCancelTo: '' });
  };

  componentDidMount() {
    this.eventListeners();
    this.getMessages();
    window.watsonAssistantChatOptions = {
      integrationID: '49f95788-0405-44f6-a87d-bc1d67b11f4c', // The ID of this integration.
      region: 'us-east', // The region your integration is hosted in.
      serviceInstanceID: '18982a6c-7095-417b-bd96-2d855e174cdd', // The ID of your service instance.
      onLoad: async (instance) => {
        await instance.render();
      },
    };
    setTimeout(function() {
      const t = document.createElement('script');
      t.src =
        'https://web-chat.global.assistant.watson.appdomain.cloud/versions/' +
        (window.watsonAssistantChatOptions.clientVersion || 'latest') +
        '/WatsonAssistantChatEntry.js';
      document.head.appendChild(t);
    });
  }

  componentWillUnmount() {
    this.worldSocket.close();
    this.countrySocket.close();
  }

  render() {
    // console.log(this.state.cancelTo, this.state.buttonAlert)
    return (
      <Fragment>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.snackOpen}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          className={this.state.snackType}
          //autoHideDuration={5000}
          onClose={this.handleClose}
          message={<span id="message-id">{this.state.snackMsg}</span>}
        />

        <TransitionDialog
          handleClose={this.handleClose}
          showNewsArticle={this.props.showNewsArticleCb}
          dialogContent={this.state.gameDialog}
          dialogPres={this.state.currentPresident}
        />
        {this.props.isDelegate ? (
          <AtgChat
            messages={this.state.messages}
            messageCount={this.state.messageCount}
            clicked={this.state.clicked}
            senderMessage={this.state.senderMessage}
            uniqueSenders={this.state.uniqueSenders}
            showBox={this.showBox}
            getMessages={this.getMessages}
            handleChange={this.handleChange}
            sendMessage={this.sendMessage}
          />
        ) : null}

        {/* <CountdownTimer time={this.state.polTime} cb={this.pollingFunctions} /> */}
        {/* <ChangesButton update={this.pollingFunctions} /> */}
        <div
          className={`${this.props.display === 'show' ? 'active' : 'hidden'}`}
        >
          <div
            className={`dash__wrap policy__dash__wrap ${
              this.props.display === 'show' ? 'active' : 'hidden'
            }`}
          >
            {this.props.roleName === 'Prime Minister' && (
              <div className="showPreviousForecast" onClick={this.openPane}>
                <strong>&lt;&lt;</strong> Forecast Pane
              </div>
            )}

            {/*{!this.props.roleName.includes("ATG") &&*/}
            {/*<div className="showPreviousForecast" onClick={this.openPane}>*/}
            {/*<strong>&lt;&lt;</strong> Forecast Pane*/}
            {/*</div>*/}
            {/*}*/}
            <div className="overlay" />
            <div className="dash__outer">
              <SignatureModal
                show={this.state.signatureModal}
                handleClose={this.hideSignatureModal}
                name={this.sName}
                countryName={this.countryName}
                roleName={this.roleName}
                hasSubmitted={this.hasSubmitted}
                propClickToSign={true}
                submitPolicies={this.submitPolicies}
                // submitPolicies={this.props.roleName === "Prime Minister" ?
                //     this.submitPolicies :
                //     this.props.roleName.includes("ATG") ?
                //         this.submitPolicies
                //         : this.addToQueue}
              />

              {!this.props.roleName.includes('ATG') ? (
                <div className="dash__inner dash__roleWiki">
                  <div className="dash__panel">
                    <div className="dash__panelWrap white oh shadow w10 pb4 pr4 pl4 pt2">
                      <div className="flex flex-auto unlist flex-justify-between">
                        <div className="container">
                          <h2>Policy Decisions</h2>
                        </div>
                        <div className="container">
                          {/*<button className="button policyBtn policyResetBtn"*/}
                          {/*onClick={e => this.fetchCurrentData(e, false)}*/}
                          {/*disabled={this.state.resetRequestSent || !this.state.hasGameStarted ? 'disabled' : false}>*/}
                          {/*{this.state.resetRequestSent ? 'Reset' : 'Reset'}*/}
                          {/*</button>*/}
                          {this.props.roleName === 'Prime Minister' && (
                            <button
                              className="button policyBtn forecastSubmitBtn"
                              onClick={this.openPane}
                              disabled={
                                this.state.forecastRequestSent ||
                                !this.state.hasGameStarted ||
                                !this.state.gameHasAdvanced
                                  ? 'disabled'
                                  : false
                              }
                            >
                              {this.state.forecastRequestSent
                                ? 'Forecasting . . .'
                                : 'Forecast'}
                            </button>
                          )}

                          {/*{this.props.roleName === "Prime Minister" &&*/}
                          {/*<button className="button policyBtn policyResetBtn"*/}
                          {/*onClick={e => this.fetchCurrentData(e, false)}*/}
                          {/*disabled={this.state.resetRequestSent || !this.state.hasGameStarted ? 'disabled' : false}>*/}
                          {/*{this.state.resetRequestSent ? 'Reset' : 'Reset'}*/}
                          {/*</button>*/}
                          {/*}*/}

                          {/*{!this.props.roleName.includes("ATG") &&*/}
                          {/*<button className="button policyBtn" onClick={this.openPane}*/}
                          {/*disabled={this.state.forecastRequestSent || !this.state.hasGameStarted ? 'disabled' : false}>*/}
                          {/*{this.state.forecastRequestSent ? 'Forecasting . . .' : 'Forecast'}*/}
                          {/*</button>*/}
                          {/*}*/}
                          <button
                            className="button policyBtn policySubmitBtn"
                            // onClick={this.showSignatureModal}
                            onClick={this.submitPolicies}
                            disabled={
                              !this.state.hasGameStarted ||
                              !this.state.gameHasAdvanced
                                ? 'disabled'
                                : false
                            }
                          >
                            {this.state.hasSubmitted
                              ? 'View Submission'
                              : 'Submit'}
                          </button>

                          {/*{this.props.roleName === "Prime Minister" ?*/}
                          {/*<button className="button policyBtn policySubmitBtn"*/}
                          {/*onClick={this.showSignatureModal}*/}
                          {/*disabled={!this.state.hasGameStarted ? 'disabled' : false}>*/}
                          {/*{this.state.hasSubmitted ? 'View Submission' : 'Submit'}*/}
                          {/*</button>*/}
                          {/*:*/}
                          {/*this.props.roleName.includes("ATG") ?*/}
                          {/*<button className="button policyBtn policySubmitBtn"*/}
                          {/*onClick={this.showSignatureModal}*/}
                          {/*disabled={!this.state.hasGameStarted ? 'disabled' : false}>*/}
                          {/*{this.state.hasSubmitted ? 'View Submission' : 'Submit'}*/}
                          {/*</button>*/}
                          {/*:*/}
                          {/*<button className="button policyBtn policySubmitBtn"*/}
                          {/*onClick={this.showSignatureModal}*/}
                          {/*disabled={!this.state.hasGameStarted ? 'disabled' : false}>*/}
                          {/*{this.state.hasSubmitted ? 'View Submission' : 'Submit to PM'}*/}
                          {/*</button>*/}
                          {/*}*/}
                        </div>
                      </div>

                      <hr />
                      <PolicyPanel
                        countryName={this.countryName}
                        polInPlay={this.state.polInPlay}
                        policyValueChanged={this.policyValueChanged}
                        isDelegate={this.props.roleName.includes('ATG')}
                        hasChanged={this.state.hasChanged}
                        alias={this.roleAlias}
                        hasGameStarted={this.state.hasGameStarted}
                        gameHasAdvanced={this.state.gameHasAdvanced}
                      />
                    </div>
                  </div>
                </div>
              ) : null}

              {/*{this.props.roleName === "Prime Minister" &&*/}
              {/*<div className="flex flex-items-center flex-justify-center gap__container">*/}
              {/*<div className="graphs__container">*/}
              {/*<div className={`shadow graphs__wrapper`}>*/}
              {/*<h3>Reasoning</h3>*/}
              {/*<hr/>*/}

              {/*<textarea name="policyReasoning" className="policy_reasoning"*/}
              {/*id="policy_reasoning" value={this.state.policyReasoning}*/}
              {/*onChange={this.handleChange}*/}
              {/*placeholder="Write reasons for why you enacted the policies and what do you expect the impacts to be...."/>*/}

              {/*</div>*/}
              {/*</div>*/}
              {/*</div>*/}
              {/*}*/}

              <MoneyTransfer
                onSendMoney={this.sendMoney}
                transferRequestSent={this.state.transferRequestSent}
                transactions={this.state.moneyTransactions}
                countryId={parseInt(this.countryId)}
                roleName={this.props.roleName}
                countryName={this.countryName}
                hasGameStarted={this.state.hasGameStarted}
                atgPres={this.state.currentPresident}
                onCancelMoney={this.onCancelMoney}
                moneyAlert={this.moneyAlert}
                cancelMoneyAlert={this.cancelMoneyAlert}
                buttonAlert={this.state.buttonAlert}
                cancelTo={this.state.cancelTo}
                gameHasAdvanced={this.state.gameHasAdvanced}
              />

              <MoneyTransfer
                onSendMoney={this.sendMoneyATG}
                transferRequestSent={this.state.transferRequestSent}
                transactions={this.state.atgTransactions}
                atgFund={this.state.atgFund}
                countryId={parseInt(undefined)}
                roleName={this.props.roleName}
                countryName={this.countryName}
                hasGameStarted={this.state.hasGameStarted}
                atgPres={this.state.currentPresident}
                onCancelATGMoney={this.onCancelATGMoney}
                atgMoneyAlert={this.atgMoneyAlert}
                cancelAtgMoneyAlert={this.cancelAtgMoneyAlert}
                atgButtonAlert={this.state.atgButtonAlert}
                atgCancelTo={this.state.atgCancelTo}
                gameHasAdvanced={this.state.gameHasAdvanced}
              />

              <br />
              <br />
            </div>
          </div>

          {!this.props.roleName.includes('ATG') && (
            <div className="policy__dash__offCanvas">
              <ForecastPane
                closePane={this.closePane}
                forecast={this.forecast}
                forecastRequestSent={this.state.forecastRequestSent}
                hasGameStarted={this.state.hasGameStarted}
                attemptsLeft={this.props.metrics.metrics.forecast_attempts}
                minInflux={this.props.world.world.asylumSeekers[0]}
                maxInflux={this.props.world.world.asylumSeekers[1]}
                forecastData={this.state.forecastData}
              />
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

PolicyDashboard.propTypes = {
  display: PropTypes.string.isRequired,
  roleName: PropTypes.string.isRequired,
  onGameComplete: PropTypes.func.isRequired,
  isDelegate: PropTypes.bool.isRequired,
  polTime: PropTypes.number,
  showNewsArticleCb: PropTypes.func,
  std: PropTypes.number,
};

export default inject('articles', 'metrics', 'world', 'policies')(
  PolicyDashboard
);
